import styled, { keyframes } from 'styled-components';

const modalAppear = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;

const StyledModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 600px;
  max-width: 95%;
  max-height: 90vh;
  overflow: hidden;
  z-index: 1050;
  animation: ${modalAppear} 0.3s ease-out;
  border: 1px solid #f3f4f6;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;


export default StyledModal;
